import React from "react";

import DENRoot, { DENContext } from "./DENRoot";
import { DENHostProps } from "./DENInterface";
import TreatmentToday from "./TreatmentToday";
import ModalItemFilterCustom from "./ModalItemFilterCustom";
import { getLockStatus, getDENRootKey } from "./DENUtils";

type CardTxProcessingProps = DENHostProps & {
  scrollable?: boolean;
  hideMenuHIS?: boolean;
};

// Tx. Processing
const CardTxProcessing = (props: CardTxProcessingProps) => (
  <DENRoot key={getDENRootKey(props)} {...props} onLoaded={handleLoaded}>{(den: DENContext) => <TxProcessing den={den} hideMenuHIS={props.hideMenuHIS} />}</DENRoot>
);

// TreatmentToday โหลดใหม่เองเมื่อ encounterId เปลี่ยน กรณีไม่มี encounter ต้องสั่งโหลดหลังได้ข้อมูลผู้ป่วย
const handleLoaded = (den: DENContext) => {
  if (!den.state.encounterId) {
    den.onEvent({ message: "refreshCurrentTreatment", params: { isFetchTreatmentIssue: true } });
  }
};

// filter ของตาราง Treatment plan
const FILTERS = [
  { element: "cardFilterDentistElement", open: "openModalFilterDentist", data: "dentistFilterListTp", message: "SetDentistFilterTp", name: "ทันตแพทย์", target: "treatment-today-filter-dentist" },
  { element: "cardFilterUrgencyLevelElement", open: "openModalFilterUrgencyLevel", data: "urgencyLevelFilterListTp", message: "SetUrgencyLevelFilterTp", name: "ระดับความเร่งด่วน", target: "treatment-today-filter-urgency" },
  { element: "cardFilterCurrentLocationElement", open: "openModalFilterCurrentLocation", data: "currentLocationFilterListTp", message: "SetCurrentLocationFilterTp", name: "Location", target: "treatment-today-filter-location" },
  { element: "cardFilterCurrentPrincipalElement", open: "openModalFilterCurrentPrincipal", data: "currentPrincipalFilterListTp", message: "SetCurrentPrincipalFilterTp", name: "Principal Diagnosis", target: "treatment-today-filter-principal" },
  { element: "cardFilterCurrentTpElement", open: "openModalFilterCurrentTp", data: "currentTpFilterListTp", message: "SetCurrentTpFilterTp", name: "Treatment Plan", target: "treatment-today-filter-tp" },
  { element: "cardFilterCurrentClinicElement", open: "openModalFilterCurrentClinic", data: "currentClinicFilterListTp", message: "SetCurrentClinicFilterTp", name: "Clinic", target: "treatment-today-filter-clinic" },
  { element: "cardFilterCurrentStatusElement", open: "openModalFilterCurrentStatus", data: "currentStatusFilterListTp", message: "SetCurrentStatusFilterTp", name: "Status", target: "treatment-today-filter-status" },
  { element: "cardFilterCurrentCreatedElement", open: "openModalFilterCurrentCreated", data: "currentCreatedFilterListTp", message: "SetCurrentCreatedFilterTp", name: "Created", target: "treatment-today-filter-created" },
] as const;

const TxProcessing = ({ den, hideMenuHIS }: { den: DENContext; hideMenuHIS?: boolean }) => {
  const { state, onEvent, setProp, setState } = den;

  const { isStudentLocked, isApproved, isDischarged, isBlank, hasNoEncounter } = getLockStatus(state);
  // checkout draft = encounter ปิดเคสแล้วแต่ยังอยู่ DRAFT → แก้ไขได้
  const readOnly = (isDischarged && isBlank) || isApproved || isStudentLocked || hasNoEncounter;

  const filterElements = Object.fromEntries(
    FILTERS.map((filter: typeof FILTERS[number]) => [
      filter.element,
      state[filter.open] ? (
        <ModalItemFilterCustom
          name={filter.name}
          data={state[filter.data]}
          onClose={() => setState({ [filter.open]: false })}
          textField="name"
          onSelect={(list: any, listArray: any) => onEvent({ message: filter.message, params: { filter: listArray } })}
          target={filter.target}
          classNameZoom=".den-module .treatment-today"
        />
      ) : null,
    ])
  );

  return (
    <div className={`treatment-today active-${state.activeIndexDiagram}`}>
      <TreatmentToday
        // function
        handleEvent={onEvent}
        setProp={setProp}
        treatmentPerformReadOnly={readOnly}
        treatmentPlanReadOnly={readOnly}
        studentLocked={isStudentLocked}
        hideMenuHIS={hideMenuHIS}
        // option
        statusExcludeCompleteOptions={state.statusExcludeCompleteOptions}
        treatmentOptions={state.treatmentOptions}
        urgencyOptions={state.urgencyOptions}
        anestheticOptions={state.anestheticOptions}
        priceChangeReasonOptions={state.priceChangeReasonOptions}
        // data
        openGallery={state.openGallery}
        treatmentIssueImageGallery={state.treatmentIssueImageGallery}
        patientData={state.PATIENT_DATA}
        divisionHasUserOptions={state.divisionHasUserOptions}
        encounterId={state.encounterId}
        encounterInfo={state.encounterInfo}
        modConfirmTreatmentPlan={state.modConfirmTreatmentPlan}
        treatmentTodayMasterData={state.treatmentTodayMasterData}
        treatmentPlanList={state.treatmentPlanList}
        treatmentPerformList={state.treatmentPerformList}
        openModChangeDisplaySeq={state.openModChangeDisplaySeq}
        showButtonSaveSeq={state.showButtonSaveSeq}
        showClinicalFindingTerms={state.showClinicalFindingTermsTreatment}
        keyboardShortcut={state.doctorProfileData?.keyboardshortcut?.filter((item: any) => item.key_type === "TR") || []}
        // Element
        {...filterElements}
        dentistFilterListTp={state.dentistFilterListTp}
        urgencyLevelFilterListTp={state.urgencyLevelFilterListTp}
        currentLocationFilterListTp={state.currentLocationFilterListTp}
        currentPrincipalFilterListTp={state.currentPrincipalFilterListTp}
        currentTpFilterListTp={state.currentTpFilterListTp}
        currentClinicFilterListTp={state.currentClinicFilterListTp}
        currentStatusFilterListTp={state.currentStatusFilterListTp}
        currentCreatedFilterListTp={state.currentCreatedFilterListTp}
      />
    </div>
  );
};

export default CardTxProcessing;
